import * as types from '../mutation-types'

// initial state
const state = {
  dynamicFood: {},
  dynamicCurche: {},
  flagFood: false,
  flagCurche: false,
  timeFood: '',
  timeCurche: ''
}

// getters
const getters = {
  dynamicFood: state => state.dynamicFood,
  dynamicCurche: state => state.dynamicCurche
}

// actions
const actions = {
  addToDynamic ({ commit, state }, obj) {
    commit(types.ADD_TO_DYNAMIC, obj)
  },

  receiveDynamic ({ commit, state }, obj) {
    commit(types.RECEIVE_DYNAMIC, obj)
  }
}

// mutations
const mutations = {
  [types.ADD_TO_DYNAMIC] (state, obj) {
    if (obj.field2 == types.DYNAMIC_FOOD_TYPE) {
      if (state.dynamicFood.dynamicList) {
        state.dynamicFood.dynamicList.unshift(obj)
      } else {
        state.dynamicFood.dynamicList = []
        state.dynamicFood.dynamicList.push(obj)
      }
      // state.flagFood = true
      // state.timeFood = new Date().getTime()
    } else if (obj.field2 == types.DYNAMIC_CURCHE_TYPE) {
      if (state.dynamicCurche.dynamicList) {
        state.dynamicCurche.dynamicList.unshift(obj)
      } else {
        state.dynamicCurche.dynamicList = []
        state.dynamicCurche.dynamicList.push(obj)
      }
      // state.flagCurche = true
      // state.timeCurche = new Date().getTime()
    }
  },
  [types.RECEIVE_DYNAMIC] (state, obj) {
    if (obj.para.dynamicType == types.DYNAMIC_FOOD_TYPE) {
      state.dynamicFood = obj
      // state.flagFood = true
      state.timeFood = new Date().getTime()
    } else if (obj.para.dynamicType == types.DYNAMIC_CURCHE_TYPE) {
      state.dynamicCurche = obj
      // state.flagCurche = true
      state.timeCurche = new Date().getTime()
    }
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./C:/vue/2.0/src/vuex/modules/dynamic.js